import { render, staticRenderFns } from "./loginAccount.vue?vue&type=template&id=21f5b02d&scoped=true&"
import script from "./loginAccount.vue?vue&type=script&lang=js&"
export * from "./loginAccount.vue?vue&type=script&lang=js&"
import style0 from "./loginAccount.vue?vue&type=style&index=0&id=21f5b02d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5b02d",
  null
  
)

export default component.exports